<div class="main-container">
    <div class="map-container" style="display: flex; justify-content: center; align-items: center;">
        <div #mapPanel [ngClass]="'mapPanel'"></div>
    </div>
    <div class="banner">
        <div [style]="{'padding-top': '1rem', 'display': 'flex', 'position': 'relative'}">
            <img src="assets/navbar-component-images/banner.svg" alt="banner.svg" >
            <img src="assets/navbar-component-images/bannerVector.svg" alt="bannerVector.svg" style="position: absolute; left: 34%; top: 35%;">
        </div>
        <h1 style="font-family: IBM Plex Sans Thai;
        font-size: 50px;
        font-weight: 600;
        line-height: 82.5px;
        letter-spacing: -0.01em;
        text-align: center;
        ">วันนี้คุณกำลังมองหาอะไร?</h1>
    </div>
    <div class="app-search-box-div">
        <app-search-box 
        [width]="'50vw'"
        (onSearch)="onSearch($event)"
        (onAiSearch)="onAiSearch($event)"></app-search-box>
    </div>
    <div class="app-trending-div">
        <app-trending></app-trending>
    </div>
    <div class="app-suggestion-div">
        <app-suggestion></app-suggestion>
    </div>
</div>
<router-outlet></router-outlet>